import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: `
        input:not([type=checkbox]):not([type=radio]):not([type=password]):not([readonly]):not(.ng-trim-ignore)[formControlName],
        input:not([type=checkbox]):not([type=radio]):not([type=password]):not([readonly]):not(.ng-trim-ignore)[formControl],
        input:not([type=checkbox]):not([type=radio]):not([type=password]):not([readonly]):not(.ng-trim-ignore)[ngModel],
        textarea:not([readonly]):not(.ng-trim-ignore)[formControlName],
        textarea:not([readonly]):not(.ng-trim-ignore)[formControl],
        textarea:not([readonly]):not(.ng-trim-ignore)[ngModel],
        :not([readonly]):not(.ng-trim-ignore)[ngDefaultControl]
    `,
    standalone: true
})
export class TrimValueDirective {
	constructor(
		private el: ElementRef,
		private model: NgControl
	) {}

	@HostListener('blur', ['$event']) onEvent($event) {
		const val = this.el.nativeElement.value.trim();
		this.model.control.setValue(val);
	}
}
